import Vue from 'vue'
import Router from 'vue-router'
import index from '../pages/index'
import signUp from '../pages/signUp'
import timeIsEnd from '../pages/timeIsEnd'
import signUpEndTime from '../utils/signUpEndTime'
Vue.use(Router)
const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/timeIsEnd',
      name: 'timeIsEnd',
      meta: {
        title: '报名时间已过'
      },
      component: timeIsEnd
    },
    {
      path: '/signUp/:source?',
      name: 'signUp',
      meta: {
        title: '酒咔嚓特别参观团-信息填写',
        timeIsEnd: signUpEndTime.isEnd
      },
      component: signUp
    },
    {
      path: '/:source?',
      name: 'index',
      meta: {
        title: '重磅尊享福利！立即报名烟台酒博会-酒咔嚓特别参观团'
      },
      component: index
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // 如果报名时间已过
  if (to.meta.hasOwnProperty('timeIsEnd')) {
    if (to.meta.timeIsEnd) {
      router.push({
        name: 'timeIsEnd'
      })
    }
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js